export const userTypes = {
  standard: 1,
  lucky_bird: 2,
} as const

export type UserType = (typeof userTypes)[keyof typeof userTypes]
